<template>
  <div class="fixed top-0 left-0 w-screen h-full bg-white text-xl" :class="{ error: error }">
    <page class="h-full">
      <template #leftBtn>
        <img
          src="../../../assets/common/back-icon.svg"
          alt="back"
          @click="$emit('update:show-confirm-token', false)"
        />
      </template>
      <template #rightBtn>
        <img
          src="../../../assets/common/close-icon.svg"
          alt="menu"
          @click="$emit('clear-active-page')"
        />
      </template>
      <template #content>
        <div>{{ $t('login.sent_a_code') }}</div>
        <div class="number">{{ phoneNumber }}</div>
        <div>{{ $t('login.received_code') }}</div>
        <div id="confirm-token" class="block-wrapper relative flex justify-between mt-8 mb-12">
          <input
            type="number"
            class="block text-center rounded outline-none"
            ref="firstInput"
            inputmode="numeric"
            maxlength="1"
            autofocus
            autocomplete="one-time-code"
            @input="splitNumber"
            @keyup="onKeyup"
          />
          <input
            maxlength="1"
            type="number"
            class="block text-center rounded outline-none"
            inputmode="numeric"
            @keyup="onKeyup"
          />
          <input
            maxlength="1"
            type="number"
            class="block text-center rounded outline-none"
            inputmode="numeric"
            @keyup="onKeyup"
          />
          <input
            maxlength="1"
            type="number"
            class="block text-center rounded outline-none"
            inputmode="numeric"
            @keyup="onKeyup"
          />
          <div v-if="error" class="error-msg absolute flex text-xs">
            <img class="mr-3" src="../../../assets/DefaultCloudzet/basic-confused.svg" />
            <span>{{ $t('login.verification_code_error') }}</span>
          </div>
        </div>
        <c-button class="my-6" @click="confirmToken">
          <span>{{ $t('login.submit') }}</span>
        </c-button>
        <div class="message text-xs">
          {{ $t('login.get_the_code') }}
          <span
            class="timer inline-block ml-2 underline"
            :class="{ 'opacity-50': seconds }"
            @click="resendSNS"
          >
            {{ $t('login.resend') }}
            <span v-if="seconds">({{ seconds }}s)</span>
          </span>
        </div>
      </template>
    </page>
  </div>
</template>

<script>
import Page from '@/components/common/Page.vue';
import CButton from '@/components/common/CButton.vue';

const KEYS_TO_SKIP = [16, 9, 224, 18, 17];

export default {
  components: {
    Page,
    CButton,
  },
  props: {
    phoneNumber: String,
    error: Boolean,
  },
  data() {
    return {
      seconds: 60,
      $inputs: null,
    };
  },
  mounted() {
    this.setTimer();
    this.$inputs = document.querySelectorAll('#confirm-token .block');
  },
  beforeDestroy() {
    this.setTimer();
  },
  methods: {
    setTimer() {
      if (!this.seconds) return;
      setTimeout(() => {
        this.seconds -= 1;
        this.setTimer();
      }, 1000);
    },
    resendSNS() {
      if (this.seconds) return;
      this.$emit('confirmed-phone-number');
      this.seconds = 60;
      this.setTimer();
    },
    onKeyup(e) {
      if (KEYS_TO_SKIP.includes(e.keyCode)) return;

      const self = e.target;
      // On Backspace or left arrow, go to the previous field.
      if (
        (e.keyCode === 8 || e.keyCode === 37) &&
        self.previousElementSibling &&
        self.previousElementSibling.tagName === 'INPUT'
      ) {
        self.previousElementSibling.select();
      } else if (
        e.keyCode !== 8 &&
        self.nextElementSibling &&
        self.nextElementSibling.tagName === 'INPUT'
      ) {
        self.nextElementSibling.select();
      }

      // If the target is populated to quickly, value length can be > 1
      if (e.target.value.length > 1) {
        this.splitNumber(e);
      }
    },
    splitNumber(e) {
      const data = e.data || e.target.value;
      if (!data || data.length === 1) return;

      this.populateNext(e.target, data);
    },
    populateNext(target, data) {
      const [newValue, ...rest] = data;
      target.value = newValue; // eslint-disable-line
      setTimeout(() => {
        target.focus();
      }, 0);
      if (target.nextElementSibling && rest.length) {
        this.populateNext(target.nextElementSibling, rest);
      }
    },
    onFocus(e) {
      const $first = this.$refs.firstInput;
      const $target = e.target;
      if (!$first.value) {
        $first.focus();
      }

      if (!$target.previousElementSibling.value) {
        $target.previousElementSibling.focus();
      }
    },
    clearInput() {
      this.$inputs.forEach(element => {
        element.value = ''; // eslint-disable-line
      });
      this.$inputs[0].focus();
    },
    getToken() {
      const token = [];
      let incorrect = false;
      this.$inputs.forEach(el => {
        const { value } = el;
        token.push(value);
        if (!value && !incorrect) {
          incorrect = true;
          el.select();
        }
      });
      return incorrect ? false : token.join('').slice(0, 4);
    },
    confirmToken() {
      const token = this.getToken();
      if (!token) return;

      this.$emit('token', token);
    },
  },
  watch: {
    error(nv, ov) {
      if (!ov && nv) {
        this.clearInput();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.number {
  color: #572bff;
}

.block-wrapper {
  width: 285px;
}

.block {
  width: 60px;
  height: 60px;
  background-color: #f5f5f5;
  &:focus {
    @apply bg-white;
    background-image: url('../../../assets/DefaultCloudzet/rectangle-1337.svg');
  }
}

.error {
  .block {
    @apply bg-white;
    background-image: url('../../../assets/DefaultCloudzet/red-border.svg');
  }
}

.error-msg {
  width: 52%;
  left: 50%;
  bottom: -44px;
  transform: translateX(-50%);
  color: #d12c2d;
}

.message {
  color: #6a6a6a;
}
</style>
